module.exports = __webpack_public_path__ + "operace-ocnich-vicek-dolni_2_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-ocnich-vicek-dolni_2_after.jpg
// module id = 1147
// module chunks = 0